import CommunicationProgramKeyUserManagmentForm from './CommunicationProgramKeyUserManagmentForm';

export default CommunicationProgramKeyUserManagmentForm;